export var AccountState;
(function (AccountState) {
    AccountState["ACCOUNT_STATE_CONNECTED"] = "CONNECTED";
    AccountState["ACCOUNT_STATE_DISCONNECTED"] = "DISCONNECTED";
    AccountState["ACCOUNT_STATE_INSUFFICIENT_PERMISSIONS"] = "INSUFFICIENT_PERMISSIONS";
    AccountState["ACCOUNT_STATE_NOT_READY"] = "NOT_READY";
    AccountState["ACCOUNT_STATE_UNSPECIFIED"] = "ACCOUNT_STATUS_UNSPECIFIED";
})(AccountState || (AccountState = {}));
